import React from 'react'

function HomePage() {
  return (
    <>
        <main>
            <div className="main_section_1_img_wrapper">
                <img src={require("./static/img/main.jpg")} alt="" />
                <h2 className="blur_div">
                    &nbsp;
                    “MARYAWTOULAG” <br />
                    ÖNÜMÇILIK BIRLEŞIGI
                    <img src={require("./static/img/arrow_down.png")} alt="" />
                </h2>
            </div>
    
            <div className="home_banner">
                <img src={require("./static/img/homeBanner.jpg")} alt="" />
            </div>
               
    
            <h3 className="organization_goals">GURAMA MAKSATLARY</h3>
                
            <div className="decoration_1">
                <img src={require("./static/img/element1.png")} alt="" />
            </div>
    
            <div className="main_section_2">
                <div className="card">
                    <img src={require("./static/img/task1.jpg")} alt="" />
                    <div className="card_text">
                        <p>Eýeçiligiň görnüşine garamazdan edaralar, kärhanalar we guramalar, ilat üçin awtomobil ulaglary bilen Türkmenistanyň ähli ýerine we çäginden daşary baglaşylan şertnama laýyklykda ýükleri daşamak, ýolagçylary gatnatmak we awtomobil gatnawlarynda hereket edýän düzgünlere we görkezmelere laýyklykda howpsuzlygy üpjin etmek;</p>
                        <img src={require("./static/img/gerb.png")} alt="" />
                    </div>
                </div>
                <div className="card">
                    <img src={require("./static/img/task2.jpg")} alt="" />
                    <div className="card_text">
                        <p>Türkmenistanyň beýleki ýurtlar bilen baglaşan awtomobil ulaglary babatdaky döwletara resminamalaryna laýyklykda daşary ýurt awtomobilleriniň Türkmenistana gelmegi we onuň çäginden üstaşyr geçmegi üçin rugsatnamalary bermegi we daşary ýurtlaryň ygtyýarly guramalary bilen rugsatnamalaryň deň mukdardaky ylalaşylan sanlaryny alyşmak hyzmatlaryny ýerine ýetirmek;</p>
                        <img src={require("./static/img/gerb.png")} alt="" />
                    </div>
                </div>
                <div className="card">
                    <img src={require("./static/img/task3.jpg")} alt="" />
                    <div className="card_text">
                        <p>Daşary ýurt döwletlere degişli awtomobil ulaglarynda ýükleri Türkmenistana getirmek we Türkmenistandan ýükleri çykarmak üçin rugsatnamalary bermek hyzmatlaryny amala aşyrmak;</p>
                        <img src={require("./static/img/gerb.png")} alt="" />
                    </div>
                </div>
                <div className="card">
                    <img src={require("./static/img/task4.jpg")} alt="" />
                    <div className="card_text">
                        <p>Awtoulaglaryň bejerilişini we tehniki taýdan hyzmat edişini ýola goýmak.</p>
                        <img src={require("./static/img/gerb.png")} alt="" />
                    </div>
                </div>
            </div>
    
            <div className="main_grid_wrapper">
    
            
                <div className="main_grid_item_1">
                    <div className="main_grid_item_1_inner_wrapper">
                        <h2>BIZ HAKDA</h2>
                        <img src={require("./static/img/element2.png")} className="decoration_2" alt="" />
                        <p>
                            “Türkmenawtoulaglary” agentliginiň 2020-nji ýylyň 31-nji martyndaky çykaran 33-Ö belgili buýrugy esasynda gaýtadan bellige alynan kärhanadyr. “Maryawtoulag” önümçilik birleşigi öz işini Türkmenistanyň “Kärhanalar hakyndaky” kanuny, Zähmet hakyndaky kanunlara we beýleki hereket edýän kanunçylyk hukuknamalaryna, “Türkmenawtoulaglary” agentliginiň buýruklaryna we görkezmelerine, Birleşigiň tertipnamasyna laýyklykda alyp barýar.
                        </p>
                    </div>
                </div>
                
                <div className="main_grid_item_2"><img src={require("./static/img/cont.jpg")} alt="" /></div>
    
                <div className="main_grid_item_3">
                    <div className="main_grid_item_3_text">
                        <img src={require("./static/img/icons/location.png")} alt="" />
                        <h2>Mary welaýaty, Mary şaheri, Ýeňişiň 50 ýyllygy köçesiniň 54-nji jaýy.</h2>
                    </div>
                </div>
                
                <img src={require("./static/img/rek.jpg")} alt="" className="main_grid_item_4" />
    
                <div className="main_grid_item_5">
                    <div className="main_grid_item_5_wrapper">
                        <h3> <b>"Ulag Ýük Hyzmatlary"</b> <br />
                            halkara ýük gatnawlar üçin sanly bazar bolup durýar.</h3>
                        <div className="main_grid_item_5_decoration">
                            <img src={require("./static/img/element2.png")} className="" alt="" />
                        </div>
                        <p>
                            Täze "Ulag Ýük Hyzmatlary" portaly ýük gatnadyjylary we müşderileri gözlemek üçin ýük gatnawlaryny gurnamak işini ýeňilleşdirýär, sargytlaryň ýerine ýetiriliş möhletini gysgaldýar we adaty operasiýalaryň netijeliligini ýokarlandyrýar.
                            Saýt ýük gatnatmak bilen meşgullanýan kärhanalary we telekeçileri, ýük gatnawlary barada hem, ýük daşaýan transportlar barada hem hilli maglumat bilen üpjün edýär. Saýtda bellige durup ulanyjy islendik transport bilen ýük daşatmak barada ýüz tutup biler, ýük gatnadyjylar bolsa öz transport hyzmatlaryny yglan edip bilerler. Ekonomikanyň sanlaşdyrylmagy zamanynda, ""Ulag Ýük Hyzmatlary" bilen bile Digital-Logistika geçmek wagty geldi.
                        </p>
                        <a href="#" className="main_grid_item_5_link">
                           <span>Geçmek</span> 
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                          </svg>
                        </a>
                    </div>
                </div>
            </div>
    
            <div className="news_title_section">
                <h2>TÄZELIKLER</h2>
                <img src={require("./static/img/element2.png")} className="" alt="" />
            </div>
    
            <div className="news_wrapper">
                <div className="news_card">
                    <a href="single_news.html">
                        <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                        <img className="news_image" src={require("./static/img/news_example_1.jpg")} alt="" />
                        <div className="news_card_inner_wrapper">
                            <div className="news_card_text_wrapper">
                                <p className="news_card_date">12.11.2022</p>
                                <h5 className="news_card_title">Türkmen samboçylary Bişkek şäherinde geçirilýän dünýä çempionatynda altyn we bürünç medallarynyň ikisini gazandylar</h5>
                                <p className="news_card_content">Türkmen samboçylary Gyrgyz Respublikasynyň Bişkek şäherinde dowam edýän 47-nji Sambo boýunça dünýä</p>
    
                            </div>
                            <p className="news_card_button">
                                <span>Giňişleýin</span> 
                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                            </p>
                        </div>
                    </a>
                </div>
    
                <div className="news_card">
                    <a href="single_news.html">
                        <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                        <img className="news_image" src={require("./static/img/news_example_2.jpg")} alt="" />
                        <div className="news_card_inner_wrapper">
                            <div className="news_card_text_wrapper">
                                <p className="news_card_date">12.11.2022</p>
                                <h5 className="news_card_title">Türkmenistanda Koreý medeniýetiniň günleriniň jemleýji güni</h5>
                                <p className="news_card_content">Türkmenistanda Koreý medeniýetiniň günleri tamamlandy. Ol dostlukly halkyň döwrebap aýdym-sazlary</p>
    
                            </div>
                            <p className="news_card_button">
                                <span>Giňişleýin</span> 
                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                            </p>
                        </div>
                    </a>
                </div>
    
                <div className="news_card">
                    <a href="single_news.html">
                        <img src={require("./static/img/element3.jpg")} className="news_card_decoration_img" alt="" />
                        <img className="news_image" src={require("./static/img/news_example_3.jpg")} alt="" />
                        <div className="news_card_inner_wrapper">
                            <div className="news_card_text_wrapper">
                                <p className="news_card_date">12.11.2022</p>
                                <h5 className="news_card_title">Türkmenistanyň Milli Geňeşiniň Mejlisiniň maslahaty</h5>
                                <p className="news_card_content">Şu gün paýtagtymyzda Türkmenistanyň Milli Geňeşiniň Mejlisiniň altynjy çagyrylyşynyň ýigrimi birinji ...</p>
    
                            </div>
                            <p className="news_card_button">
                                <span>Giňişleýin</span> 
                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi-chevron-right" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                              </svg>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </main>
    
        

    </>
  )
}

export default HomePage